import React, { useState, useEffect } from 'react';
import classes from './ShowImage.module.scss';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faTimes } from '@fortawesome/free-solid-svg-icons';

const ShowImage = ({ src, onClosed }) => {
  const [displayNone, setDisplayNone] = useState(true);

  useEffect(()=> {
    if (src && displayNone) {
      setDisplayNone(false);
    }
  }, [src, displayNone]);

  if (displayNone) return <div></div>;

  const rootClass = [classes.ShowImage];
  if (src) rootClass.push(classes.Show);
  else rootClass.push(classes.Hide);

  const animationEnd = ()=> {
    if (!src) {
      setDisplayNone(true);
    }
  }

  return (
    <div className={rootClass.join(' ')} onAnimationEnd={animationEnd}>
      <div className={classes.Backdrop} onClick={onClosed}></div>

      <img src={src} alt="" className={classes.Image} />

      <button className={classes.CloseButton} onClick={onClosed}>
        {/* <FontAwesomeIcon icon={faTimes} color="inherit" fontSize="inherit" /> */}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"></path>
        </svg>
      </button>
    </div>
  );
}

export default ShowImage;
